import { UseMutateFunction } from "@tanstack/react-query";
import { AxiosError } from "axios";
import * as yup from "yup";

export interface ExpenseCategoryModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  categoryData?: any;
  mutate: UseMutateFunction<
    ExpenseCategoryAddResponse,
    AxiosError<any>,
    any,
    unknown
  >;
}

export interface ExpenseCategoryAddRequest {
  id?: number;
  name: string;
}

export interface ExpenseCategoryAddResponse
  extends Array<ExpenseCategoryUpdateResponse> {
  status?: number;
}

export interface ExpenseCategoryUpdateRequest {
  name: string;
}

export interface ExpenseCategoryUpdateActiveRequest {
  id: string;
  is_active?: boolean;
  is_visible?: boolean;
}

export interface ExpenseCategoryUpdateResponse {
  id: number;
  name: string;
  total_cost: number;
  status?: number;
}

export interface ExpenseCategoryUpdateRequest {
  id?: number;
  name: string;
}

export interface ExpenseCategoryDeleteModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  categoryData?: any;
  modalType?: string;
  userData?: any;
  categoryId?: string;
  mutate: UseMutateFunction<
    ExpenseAddResponse,
    AxiosError<any>,
    ExpenseListRequest,
    unknown
  >;
}

export interface CostDeleteModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  userData?: any;
  categoryId?: string;
  mutate: UseMutateFunction<
    ExpenseDetailResponse,
    AxiosError<any>,
    ExpenseListRequest,
    unknown
  >;
}

export interface ExpenseAddRequest {
  category?: number;
  id?: number;
  name: string;
}

export interface ExpenseListRequest {
  id?: string;
}

export interface ExpenseAddResponse extends Array<ExpenseUpdateResponse> {
  status?: number;
}

export interface ExpenseUpdateRequest {
  name: string;
}

export interface ExpenseUpdateResponse {
  id: number;
  name: string;
  total_cost: number;
  status?: number;
}

export interface ExpenseUpdateRequest {
  id?: string;
  name: string;
  category?: string;
}

export interface ExpenseModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  categoryData?: any;
  categoryId?: string;
  pageName?: string;
  mutate: UseMutateFunction<
    ExpenseAddResponse,
    AxiosError<any>,
    ExpenseListRequest,
    unknown
  >;
}

export interface CostModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  categoryData?: any;
  categoryId?: string;
  mutate: UseMutateFunction<
    ExpenseDetailResponse,
    AxiosError<any>,
    ExpenseListRequest,
    unknown
  >;
}

type Expense = {
  id: number;
  category: number;
  amount: number;
  name: string;
  description: string;
};

export interface ExpenseDetailResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: Expense[];
}

export interface CostAddRequest {
  id: number;
  category?: string;
  amount?: number;
  name?: string;
  description?: string;
  is_active?: boolean;
  is_visible?: boolean;
}

export interface CostListRequest {
  id?: string;
}

export interface CostAddResponse extends Array<CostUpdateResponse> {
  status?: number;
}

export interface CostUpdateRequest {
  id: number;
  category?: string;
  amount?: number;
  name?: string;
  description?: string;
  is_active?: boolean;
  is_visible?: boolean;
}

export interface CostUpdateResponse {
  id: number;
  name: string;
  total_cost: number;
  status?: number;
}

export const ExpenseCategoryAddSchema = yup.object().shape({
  name: yup.string().required("Kategori adı boş bırakılamaz"),
});

export const ExpenseSubCategoryAddSchema = yup.object().shape({
  name: yup.string().required("Gider adı boş bırakılamaz"),
});

export const ExpenseSchema = yup.object().shape({
  name: yup.string().required("Gider adı boş bırakılamaz"),
  description: yup.string().required("Gider açıklaması boş bırakılamaz"),
  amount: yup.string().required("Gider miktarı boş bırakılamaz"),
});

export const assignType = {
  ASSING_OWN: "ME",
  ASSING_ALL: "ALL",
  ASSING_PERSON: "PERSON",
};

export const assignPersonOptions = [
  { key: "Herkese", value: assignType.ASSING_ALL },
  { key: "Kendime", value: assignType.ASSING_OWN },
  { key: "Çalışan", value: assignType.ASSING_PERSON },
];

export const assignFormatter = (selectedId?: string, userId?: number) => {
  if (selectedId == userId) return assignType.ASSING_OWN;
  if (selectedId != userId && selectedId !== undefined)
    return assignType.ASSING_PERSON;

  return assignType.ASSING_ALL;
};
